import { NBSP } from '../../../../../../../../constants/symbols';
import { createService } from '../../createService';

export const InitialBetService = createService({
  title: 'Ваша ставка',
  subTitle: 'Выберите свою ставку',
  description: `Поднимите ставку до${NBSP}Топа и${NBSP}получите больше просмотров и${NBSP}звонков`,
  dataName: 'InitialBetService',
  bgColor: 'white',
  icon: null,
});
